
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data-science-development-company",
      function () {
        return require("private-next-pages/data-science-development-company.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data-science-development-company"])
      });
    }
  